module.exports = __webpack_public_path__ + "static/media/oracle.5a366a8e.svg";